<script>
import MetisMenu from "metismenujs/dist/metismenujs";

import Vue from "vue";
import { mapState } from "vuex";

/**
 * Sidenav component
 */

export default {
  data() {
    return {
      openGroups: {}, // { itemId: true/false }
      menuData: null,
      checkMounted: true,
      menu: [],
    };
  },
  created() {
    //
    var currentUser = localStorage.getItem("auth-user");

    if (currentUser) {
      let data = JSON.parse(currentUser);
      if (data && data.menu) this.menu = data.menu;
      // console.info("LOG ON CREATED : SIDE - NAV ", this.menu);
    }
  },
  computed: {
    ...mapState("snackBarStore", ["isMenuAction"]),
  },
  watch: {
    isMenuAction: {
      deep: true,

      handler(val) {
        // 👈 THÊM LOGIC ẨN/HIỆN SIDEBAR Ở ĐÂY
        document.body.classList.toggle("sidebar-closed");

        // // ... (Giữ nguyên các logic MetisMenu và handleMenuActive cũ) ...
        // var currentMenu = localStorage.getItem("currentMenuId");
        // var menuRef = new MetisMenu("#side-menu");
        // var links = document.getElementsByClassName("side-nav-link-ref active");
        // var chil = links[0];
        // if (chil) {
        //   chil.classList.remove("active");
        //   var parent = chil.parentElement;
        //   if (parent) parent.classList.remove("mm-active");
        // }

        this.handleMenuActive(); // Gọi lại hàm tìm kiếm và active
      },
    },
  },
  mounted: function () {
    var currentMenu = localStorage.getItem("currentMenuId");

    var menuRef = new MetisMenu("#side-menu");
    var links = document.getElementsByClassName("side-nav-link-ref");

    var matchingMenuItem = null;
    const paths = [];
    for (var i = 0; i < links.length; i++) {
      paths.push({
        link: links[i].getAttribute("pathname"),
        menuId: links[i].getAttribute("menuId"),
      });
    }
    const currentPath = window.location.pathname;

    // 1. Gỡ bỏ trạng thái Active cũ khỏi tất cả các liên kết
    for (const link of links) {
      if (link.classList.contains("active")) {
        link.classList.remove("active");
        // Cũng gỡ bỏ mm-active/mm-show của các thẻ cha (li)
        let parentLi = link.closest("li.mm-active");
        if (parentLi) parentLi.classList.remove("mm-active");
        let parentUl = link.closest("ul.mm-show");
        if (parentUl && parentUl.id !== "side-menu") parentUl.classList.remove("mm-show");
      }
    }

    // 2. Tìm kiếm chính xác đường dẫn khớp
    for (let i = 0; i < links.length; i++) {
      const linkPath = links[i].getAttribute("pathname");
      // Kiểm tra đường dẫn khớp hoàn toàn
      if (linkPath === currentPath) {
        matchingMenuItem = links[i];
        break;
      }
    }

    // 3. Nếu không tìm thấy khớp chính xác, thử tìm khớp đường dẫn cha
    if (!matchingMenuItem) {
      // Ví dụ: Đang ở /tai-khoan/chi-tiet, nhưng menu chỉ có /tai-khoan
      for (let i = 0; i < links.length; i++) {
        const linkPath = links[i].getAttribute("pathname");
        // Kiểm tra nếu đường dẫn hiện tại BẮT ĐẦU bằng đường dẫn menu (ví dụ: /tai-khoan/...)
        if (currentPath.startsWith(linkPath) && linkPath !== '/') {
          matchingMenuItem = links[i];
          // Đừng break, để nó tìm kiếm đường dẫn cha gần nhất (dài nhất)
        }
      }
    }

    // --- Kết thúc phần sửa chữa ---

    if (matchingMenuItem) {
      // ... (Giữ nguyên logic MetisMenu kích hoạt thẻ active và thẻ cha mm-active/mm-show) ...
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("mm-active");
        const parent2 = parent.parentElement.closest("ul");
        if (parent2 && parent2.id !== "side-menu") {
          parent2.classList.add("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("mm-active");
            var childAnchor = parent3.querySelector(".has-arrow");
            var childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4 && parent4.id !== "side-menu") {
              parent4.classList.add("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5 && parent5.id !== "side-menu") {
                parent5.classList.add("mm-active");
                const childanchor = parent5.querySelector(".is-parent");
                if (childanchor && parent5.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
  },
  methods: {
    toggleCollapse(item) {
      item.collapsed = !item.collapsed;
    },
    toggleGroup(id) {
      this.$set(this.openGroups, id, !this.openGroups[id]);
    },
    isOpen(id) {
      return this.openGroups[id];
    },
    handleMenuActive() {
      var currentMenu = localStorage.getItem("currentMenuId");

      var menuRef = new MetisMenu("#side-menu");
      var links = document.getElementsByClassName("side-nav-link-ref");

      var matchingMenuItem = null;
      const paths = [];
      for (var i = 0; i < links.length; i++) {
        paths.push({
          link: links[i].getAttribute("pathname"),
          menuId: links[i].getAttribute("menuId"),
        });
      }
      var itemIndex = paths.findIndex(
        (x) => (x.link = window.location.pathname && x.menuId == currentMenu)
      );
      if (itemIndex === -1) {
        const strIndex = window.location.pathname.lastIndexOf("/");
        const item = window.location.pathname.substr(0, strIndex).toString();
        matchingMenuItem = links[paths.findIndex((x) => x.link == item)];
      } else {
        matchingMenuItem = links[itemIndex];
      }

      if (matchingMenuItem) {
        matchingMenuItem.classList.add("active");
        var parent = matchingMenuItem.parentElement;

        /**
         * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
         * We should come up with non hard coded approach
         */
        if (parent) {
          parent.classList.add("mm-active");
          const parent2 = parent.parentElement.closest("ul");
          if (parent2 && parent2.id !== "side-menu") {
            parent2.classList.add("mm-show");

            const parent3 = parent2.parentElement;
            if (parent3) {
              parent3.classList.add("mm-active");
              var childAnchor = parent3.querySelector(".has-arrow");
              var childDropdown = parent3.querySelector(".has-dropdown");
              if (childAnchor) childAnchor.classList.add("mm-active");
              if (childDropdown) childDropdown.classList.add("mm-active");

              const parent4 = parent3.parentElement;
              if (parent4 && parent4.id !== "side-menu") {
                parent4.classList.add("mm-show");
                const parent5 = parent4.parentElement;
                if (parent5 && parent5.id !== "side-menu") {
                  parent5.classList.add("mm-active");
                  const childanchor = parent5.querySelector(".is-parent");
                  if (childanchor && parent5.id !== "side-menu") {
                    childanchor.classList.add("mm-active");
                  }
                }
              }
            }
          }
        }
      }
    },
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    hasItems(item) {
      return item.children !== undefined ? item.children?.length > 0 : false;
    },
    toggleMenu(event) {
      event.currentTarget.nextElementSibling.classList.toggle("mm-show");
    },
    handleGetIdMenu(path, id) {
      Vue.prototype.menuId = id;
      localStorage.setItem("currentMenuId", id);
      if (path != window.location.pathname) this.$router.push(path);
      // this.$store.dispatch(
      //   "snackBarStore/clickMenu",
      //   !this.$store.state.snackBarStore.isMenuAction
      // );
    },
    getCount(id) {
      var resultData = this.menu.filter((x) => {
        return x.id == id;
      });
      //  console.log("LOG ID GET COUNT : ", id , resultData)
      if (resultData.length > 0) {
        return resultData[0].soLuong;
      }
      return 0;
    },
  },
};
</script>

<template>
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul id="side-menu" class="metismenu list-unstyled">
      <template v-for="item in menu">
        <li class="menu-title" v-if="item != null && item.name" :key="item._id">
          {{ item.name }}
        </li>
        <template v-if="hasItems(item)">
          <li v-for="value in item.children" :key="value._id">
            <a :menuId="value._id" :pathname="value.link" style="cursor: pointer"
              @click="handleGetIdMenu(value.link, value._id)" class="side-nav-link-ref">
              <i :class="`${value.icon}`" v-if="value.icon"></i>
              <span>{{ value.name }}</span>
            </a>
          </li>
        </template>
      </template>
    </ul>
  </div>
</template>
<style scoped>
/* ======================== SCOPED SIDENAV STYLES ======================== */

/* --- 1. BASE STYLES & FONT --- */

#sidebar-menu {
  height: auto;
  padding-bottom: 40px;
}

/* Menu Titles */
.menu-title {
  font-size: 14px !important;
  padding: 12px 20px;
  font-weight: bold;
  text-transform: uppercase;
  align-items: center;
  justify-content: flex-start;
}

/* Menu Items (Anchor tag) */
#sidebar-menu ul li a {
  color: var(--on-surface);
  padding: 12px 25px;
  display: flex;
  transition: all 0.15s ease;
  white-space: nowrap;
  /* Ngăn text bị xuống dòng sớm */
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  margin: 10px 0;
  align-items: center;
  justify-content: flex-start;
}

/* ICON mặc định */
#sidebar-menu ul li a i {
  font-size: 18px;
  margin-right: 5px;
  color: var(--on-surface-variant);
  transition: color 0.15s ease;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  margin: 0;
}

#sidebar-menu ul li a i:hover {
  color: var(--surface) !important;
  border-radius: 12px;
  size: 1rem;
}

/* ------------------------------------- */
/* --- 2. TRẠNG THÁI HOVER --- */
/* ------------------------------------- */

#sidebar-menu ul li a:hover {
  color: var(--on-primary) !important;
  background-color: var(--primary);
  font-weight: 600;
  /* padding: 10px;
  margin: 10px; */
  margin: 10px;
  border-radius: 16px;
}

#sidebar-menu ul li a.active:hover {
  color: var(--on-primary) !important;
  background-color: var(--primary) !important;
  font-weight: 600;
  /* padding: 10px;
  margin: 10px; */
  margin: 10px 0;
  border-radius: 16px;
  /*transform: scale(1.05);*/
}

/* ------------------------------------- */
/* --- 3. TRẠNG THÁI ACTIVE (ĐANG CHỌN) --- */
/* ------------------------------------- */

/* Dành cho item đang được chọn */
.mm-active>a,
.side-nav-link-ref.active {
  color: var(--on-primary) !important;
  background-color: var(--primary);
  font-weight: 600;
  /* padding: 10px; */
  margin: 10px 10px !important;
  border-radius: 16px;
}

/* Icon của item đang được chọn */
.mm-active>a i,
.side-nav-link-ref.active i {
  color: var(--on-primary) !important;
}

.mm-active>a i,
.side-nav-link-ref:hover i {
  color: var(--on-primary) !important;
}

/* Gạch chân bên trái cho item Active */
.side-nav-link-ref.active {
  margin: 10px 0;
}
</style>
